// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"23aa8132","946":"567fd56b"}[chunkId] + ".chunk.js";
};